import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    location: "bottom start",
    "close-on-content-click": true,
    disabled: _ctx.readonly
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps(props, {
        color: _ctx.accent ? 'primary' : 'surface',
        variant: _ctx.accent ? 'tonal' : 'flat',
        rounded: "pill",
        size: "small",
        "append-icon": _ctx.readonly ? undefined : 'mdi-chevron-down',
        class: "chip-select",
        border: !_ctx.accent
      }), {
        default: _withCtx(() => [
          (_ctx.icon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                icon: _ctx.icon,
                size: "small",
                start: ""
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.modelValue || _ctx.placeholder), 1)
        ]),
        _: 2
      }, 1040, ["color", "variant", "append-icon", "border"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        density: "compact",
        "max-height": "280",
        class: "pa-1"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalized, (opt) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: opt.value,
              active: opt.value === _ctx.modelValue,
              rounded: "md",
              onClick: ($event: any) => (_ctx.$emit('update:modelValue', opt.value))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(opt.value), 1)
                  ]),
                  _: 2
                }, 1024),
                (opt.sub)
                  ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(opt.sub), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["active", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["disabled"]))
}